import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476ee2e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "jmeno" }, "Jméno", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "prijmeni" }, "Příjmení", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "prijmeni" }, "Datum narození", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ulice" }, "Ulice", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mesto" }, "Město", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "psc" }, "PSČ", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "telefon" }, "Telefon", -1))
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "poznamka" }, "Poznámka (max. 500 znaků)", -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "jak-se-o-nas-dozvedeli" }, "Jak jste se o nás dozvěděli?", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "inzerát" }, "Inzerát", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "sociální sítě" }, "Sociální sítě", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "od kamaráda" }, "Od kamaráda", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "jiné" }, "Jiné", -1))
const _hoisted_25 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "co-chcete-objednat" }, "Co chcete objednat?", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buttons" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "action-button"
  }, "Odeslat")
], -1))

import CommonPage from "@/components/CommonPage.vue";
import { reactive } from "vue";
import emailjs from "emailjs-com";
import { toast, type ToastOptions } from "vue3-toastify";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormView',
  setup(__props) {

const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const options = ["Bystřička", "Dunajec", "Kurzy", "Řecko", "Roháče"];

const state = reactive({
  jmeno: "",
  prijmeni: "",
  ulice: "",
  narozeni: new Date(1980, 1, 1),
  mesto: "",
  psc: "",
  telefon: "",
  email: "",
  poznamka: "",
  info: "",
  objednat: "",
});

const sendEmail = async () => {
  // Validace formuláře
  if (!state.jmeno) {
    alert("Zadejte jméno.");
    return;
  }

  if (!state.prijmeni) {
    alert("Zadejte příjmení.");
    return;
  }

  if (!state.ulice) {
    alert("Zadejte ulici.");
    return;
  }

  if (!state.mesto) {
    alert("Zadejte město.");
    return;
  }

  if (!state.psc) {
    alert("Zadejte PSČ.");
    return;
  }
  if (!state.narozeni) {
      alert("Zadejte datum narození.");
      return;
  }
  if (!state.telefon) {
    alert("Zadejte telefonní číslo.");
    return;
  }

  if (!state.email) {
    alert("Zadejte e-mailovou adresu.");
    return;
  } else if (!state.email.match(emailRegex)) {
    alert("E-mailová adresa není platná.");
    return;
  }

  const stateString = Object.entries(state)
    .map(([key, value]) => `${key}: '${value}'`)
    .join(", ");
  toast.info("Objednávka se odesílá");
  try {
    emailjs.init("iYzmrNBAjQVKCYZOj");
    emailjs.send("service_lkxysdh", "template_eit7a5r", {
      from_name: `${state.jmeno} ${state.prijmeni}`,
      jmeno: state.jmeno,
      prijmeni: state.prijmeni,
      narozeni: state.narozeni,
      ulice: state.ulice,
      mesto: state.mesto,
      psc: state.psc,
      telefon: state.telefon,
      email: state.email,
      poznamka: state.poznamka,
      info: state.info,
      objednat: state.objednat,
      event: state.objednat,
      message: stateString,
      reply_to: state.email,
      from_email: state.email,
    });
    toast.success("Objednávka byla úspěšně odeslána");
  } catch (e) {
    console.log(e);
    toast.error("Nastala nečekaná chyba, zkuste to prosím později.");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "Objednávky" }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(sendEmail, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "jmeno",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.jmeno) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.jmeno,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "prijmeni",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.prijmeni) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.prijmeni,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-control",
            id: "narozeni",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.narozeni) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.narozeni,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "ulice",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.ulice) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.ulice,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "mesto",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.mesto) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.mesto,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "psc",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.psc) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.psc,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-control",
            id: "telefon",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.telefon) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.telefon,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-control",
            id: "email",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.email) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              state.email,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            placeholder: "Zde můžete dopsat pro kolik osob. Jejich jméno, věk a adresu.",
            id: "poznamka",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.poznamka) = $event)),
            maxlength: "500",
            rows: "3"
          }, null, 512), [
            [_vModelText, state.poznamka]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            id: "jak-se-o-nas-dozvedeli",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((state.info) = $event)),
            required: ""
          }, _hoisted_25, 512), [
            [_vModelSelect, state.info]
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            id: "co-chcete-objednat",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.objednat) = $event)),
            required: ""
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item, index) => {
              return _createElementVNode("option", {
                key: 'order_' + index,
                value: item
              }, _toDisplayString(item), 9, _hoisted_28)
            }), 64))
          ], 512), [
            [_vModelSelect, state.objednat]
          ])
        ]),
        _hoisted_29
      ], 32)
    ]),
    _: 1
  }))
}
}

})